import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { postRequest, displayMessage } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';

import { put, takeEvery, call } from 'redux-saga/effects';

function* listener(serviceType, action) {
    try {
        yield put(createServiceAction(serviceType, 'loading')());
        if (action.data) {
            const options = {
                users: action.data.users
            };
            const infoPopDuration = 1000;
            yield call(displayMessage, 'info', `Updating Licensees...`, infoPopDuration);
            const res = yield call(postRequest, apiConfig.setLicensee.endPointUrl, options);
            const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res, infoPopDuration);
            if (!statusErrorMessage) {
                const response = yield res.json();
                // Display server error message
                const serverErrorMessage = yield call(getServerValidationMessage, response, infoPopDuration);
                if (!serverErrorMessage && response.errorCode === 0) {
                    yield put(createServiceAction(serviceType, 'success')(response));
                    const message = `${response.message}`;
                    // Display success message
                    yield call(displayMessage, 'success', message, 5000);
                    yield put(createServiceAction('listLicensee', 'requested')(action.data.listParams));

                }
            }
        } else {
            yield put(createServiceAction(serviceType, 'success')({}));
        }
    } catch (e) {
        yield put(createServiceAction(serviceType, 'error')(e));
    }
}

function* addLicenseeSearchSagas() {
    const serviceType = 'setLicensee';
    yield takeEvery(createServiceAction(serviceType, 'requested').type, listener, serviceType);
}

export default addLicenseeSearchSagas;
